(function () {
  function startTimer(duration, display) {
    if (display.countDownHandle) {
      clearTimeout(display.countDownHandle);
    }
    var timer = duration, minutes, seconds;
    display.countDownHandle = setInterval(function () {
      minutes = parseInt(timer / 60, 10);
      seconds = parseInt(timer % 60, 10);

      minutes = minutes < 10 ? "0" + minutes : minutes;
      seconds = seconds < 10 ? "0" + seconds : seconds;

      if (minutes && minutes !== "00") {
        display.textContent = minutes + " Minutes";
      }
      else {
        display.textContent = seconds + " Seconds";
      }
      if (--timer < 0) {
        timer = duration;
      }
    }, 1000);
  }

  function initalizeCountDowns() {
    var elements = document.querySelectorAll('[data-count-down]');
    if (elements && elements.length) {
      for (element of elements) {
        if (element.dataset && element.dataset['countDown']) {
          var timeout = parseInt(element.dataset['countDown']);
          startTimer(timeout, element);
        }
      }
    }
  }

  function init() {
    initalizeCountDowns();
    Livewire.hook('message.processed', initalizeCountDowns);
  }

  window.addEventListener("DOMContentLoaded", function () {
    init();
  });
  if (document.readyState === "complete") {
    init();
  }
})();